exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".searchWrapper {\n  width: 300px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/hq/cards/copy-configuration/copy-from-product/copy-from-product.component.css
// module id = ../../../../../src/app/hq/cards/copy-configuration/copy-from-product/copy-from-product.component.css
// module chunks = main